import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Title from '../Title';
import { RateCardStyled, WrapperLeftPart, WrapperRightPart } from './styles/RateCardStyled';

const RateCard = ({ countMonth, price, onClick }) => (
  <RateCardStyled onClick={onClick}>
    <WrapperLeftPart>
      <Title color="gray_nightrider" font="din_medium">
        {countMonth}
      </Title>
    </WrapperLeftPart>
    <WrapperRightPart>
      <Title color="gray_nightrider">{price}</Title>
    </WrapperRightPart>
  </RateCardStyled>
);

RateCard.propTypes = {
  countMonth: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

RateCard.defaultTypes = {
  countMonth: '1 месяц',
  price: '129 грн',
};

export default memo(RateCard);
